export const ACCOUNT_PREFIX = '/:accountName';
export const PORTAL_PREFIX = `${ACCOUNT_PREFIX}/portal_`;

export const REQUEST_BASE_ROUTE = '/portal_';
